import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import DocumentContext from "components/DocumentContext";
import Guidelines from "components/Guidelines";
import PageWrapper from "components/PageWrapper";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
    },
}));

export const GuidelinesPage = () => {
    const classes = useStyles();

    return (
        <PageWrapper className={classes.root}>
            <DocumentContext
                addBrandNameSuffix
                title="Community Guidelines"
                description="We believe that safety and belonging create the greatest opportunities for understanding, connection, and growth."
            />
            <Typography variant="overline">Creating brave spaces</Typography>

            <Guidelines mainHeadingVariant="h1" />
        </PageWrapper>
    );
};

export default GuidelinesPage;
